import Vue from 'vue'
import global_ from '@/resource/js/GLOBAL2'
/**引入public样式**/
import "@/assets/css/public.css"
import '@/assets/icon/iconfont.css'
/**引入样式基准文件**/
require('@/resource/js/rem');
// require('@/resource/js/analysis');
require('@/resource/js/share_global');
/**引入全局分享**/
require('@/resource/js/ANALYSIS2');
require('@/resource/js/baiduAnalysis');
/**引入全局组件 弱提示prompt**/
import prompt from '@/components/prompt/prompt'
import messageBox from '@/components/messageBox/messageBox'
import messageBoxCancle from '@/components/messageBoxCancle/messageBoxCancle'
import confirm from '@/components/confirm'


/**
 * 定义全局GLOBAL
 * this.GLOBAL引用
 * this.invokeApi引用接口调取
 * this.GLOBAL.XXX引用GLOBAl的输出方法及变量
 * **/
Vue.prototype.GLOBAL = global_;
Vue.prototype.invokeApi = global_.invokeApi;
Vue.prototype.getPlatformId = global_.getPlatformId;
Vue.prototype.GetQueryString = global_.GetQueryString;
Vue.prototype.$prompt = prompt;
Vue.prototype.$messageBox = messageBox;
Vue.prototype.$messageBoxCancle = messageBoxCancle;
Vue.prototype.$confirm = confirm;
window.invokeApi = global_.invokeApi;




// WEBPACK FOOTER //
// ./src/resource/js/global_public.js